export const environment = {
    AUTH0_DOMAIN: 'login.development.legitscript.net',
    AUTH0_CLIENT_ID: 'EfLo0hwTQ0oQI6eGhWmQX0XRnmEcMoaR',
    AUTH0_REDIRECT_URI: 'https://test-transactions.development.legitscript.net/#/loading',
    AUTH0_AUDIENCE: 'https://api.legitscript.com',
    TEST_TRANSACTIONS_HOST: 'https://8gmj9f3fd5.execute-api.us-west-2.amazonaws.com/development',
    MYLS_HOST: 'https://my-beta.legitscript.com'
};
